function createWavePath({
  startX,
  endX,
  centerY,
  amplitude,
  halfWaveWidth,
}: {
  startX: number;
  endX: number;
  centerY: number;
  amplitude: number;
  halfWaveWidth: number;
}) {
  let path = `M${startX},${centerY}`;
  let direction = -1;

  for (let x = startX; x < endX; x += halfWaveWidth) {
    const controlY = centerY + direction * amplitude;
    path += ` C${x + halfWaveWidth / 3},${controlY} ${x + (halfWaveWidth * 2) / 3},${controlY} ${x + halfWaveWidth},${centerY}`;
    direction *= -1;
  }

  return path;
}

const smallWave = createWavePath({
  startX: -18,
  endX: 36,
  centerY: 6,
  amplitude: 4.5,
  halfWaveWidth: 4.5,
});

const defaultWave = createWavePath({
  startX: -48,
  endX: 96,
  centerY: 12,
  amplitude: 10,
  halfWaveWidth: 12,
});

export function WavyLine({
  opacity = 0.1,
  size,
  color = "var(--text-primary)",
}: {
  opacity?: number;
  size?: number;
  color?: string;
} = {}) {
  const wave = size ? smallWave : defaultWave;
  const translation = size ? -18 : -48;

  return (
    <svg
      width={size || 32}
      height={size || 24}
      viewBox={size ? "0 0 12 12" : "0 0 32 24"}
      style={{ overflow: "hidden", opacity }}
    >
      <g>
        <animateTransform
          attributeName="transform"
          type="translate"
          from="0 0"
          to={`${translation} 0`}
          dur="2s"
          repeatCount="indefinite"
        />
        <path
          d={wave}
          fill="none"
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}
